<template>
  <div class="drawer">
    <el-drawer
      size="1500px"
      title="设置门店业绩目标"
      :visible.sync="drawerStatus"
      @close="handleClose"
    >
      <div style="padding-bottom: 40px">
        <el-row class="row">
          <el-col :span="24">
            <span class="label" style="vertical-align: middle">所选月份：</span>
            <span class="value" style="vertical-align: middle">
              {{ datas.month_info }}
            </span>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="24">
            <span class="label" style="vertical-align: middle"
              >设置周数计算值：</span
            >
            <span class="value" style="vertical-align: text-top">
              <div style="margin-left: 10px">
                <div
                  v-for="(week, index) in datas.week_setting_list"
                  :key="index"
                  style="margin-bottom: 10px"
                >
                  {{ week.weekName }}:
                  <el-date-picker
                    v-model="week.datePickerValue"
                    type="daterange"
                    range-separator="至"
                    @change="changeDatePickerValue"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    size="mini"
                  >
                  </el-date-picker>
                  <img
                    v-if="datas.week_setting_list.length === index + 1"
                    style="
                      width: 20px;
                      height: 20px;
                      vertical-align: middle;
                      margin: 4px;
                      cursor: pointer;
                    "
                    @click="jia"
                    src="../../../assets/img/shuju/jia.png"
                  />
                  <img
                    v-if="
                      datas.week_setting_list.length === index + 1 &&
                      datas.week_setting_list.length > 1
                    "
                    style="
                      width: 20px;
                      height: 20px;
                      vertical-align: middle;
                      margin: 4px;
                      cursor: pointer;
                    "
                    @click="jian"
                    src="../../../assets/img/shuju/jian.png"
                  />
                </div>
              </div>
            </span>
          </el-col>
        </el-row>

        <el-row class="row">
          <el-col :span="24">
            <span class="label">门店流水月目标：</span>
            <span class="value">
              <div class="table">
                <div class="tableRow">
                  <div class="cell">门店</div>
                  <!-- <div class="cell">上月业绩</div> -->
                  <div class="cell">本月业绩目标</div>
                  <!-- <div class="cell">上月活体</div> -->
                  <div class="cell">本月活体目标</div>
                  <div
                    class="cell"
                    v-for="(item, index) in datas.week_setting_list"
                    :key="index"
                  >
                    {{ item.weekName }}
                  </div>
                </div>

                <div
                  class="tableRow"
                  v-for="(shop, index) in datas.shop_setting_list"
                  :key="index"
                >
                  <div class="cell">
                    {{ shop.shop_info && shop.shop_info.shop_name }}
                  </div>
                  <!-- <div class="cell">{{ shop.last_month_performance }}</div> -->
                  <div class="cell">
                    <el-input
                      size="mini"
                      v-model="shop.month_target"
                      style="width: 100px"
                      @input="inputMoney1(shop)"
                    ></el-input>
                  </div>
                  <!-- <div class="cell">{{ shop.last_living_performance }}</div> -->
                  <div class="cell">
                    <el-input
                      size="mini"
                      style="width: 80px"
                      v-model="shop.living_target"
                      @input="inputMoney2(shop)"
                    ></el-input>
                  </div>
                  <div
                    class="cell"
                    v-for="(item, index) in datas.week_setting_list"
                    :key="index"
                  >
                    <input
                      type="text"
                      style="
                        width: 70px;
                        height: 20px;
                        border-radius: 5px;
                        border: 1px solid #dcdfe6;
                      "
                      class="week"
                    />
                  </div>
                </div>
              </div>
            </span>
          </el-col>
        </el-row>

        <!-- <el-row class="row">
          <el-col :span="24">
            <span class="label">门店活体月目标：</span>
            <span class="value">
              <div class="table">
                <div class="tableRow">
                  <div class="cell">门店</div>
                  <div class="cell">上月业绩</div>
                  <div class="cell">本月目标</div>
                  <div class="cell">设置方式</div>
                </div>
                <div
                  class="tableRow"
                  v-for="(shop, index) in datas.shop_setting_list"
                  :key="index"
                >
                  <div class="cell">
                    {{ shop.shop_info && shop.shop_info.shop_name }}
                  </div>
                  <div class="cell">{{ shop.last_living_performance }}</div>
                  <div class="cell">
                    <el-input
                      size="mini"
                      v-model="shop.living_target"
                      style="width: 100px"
                      @input="inputMoney2(shop)"
                    ></el-input>
                  </div>
                  <div class="cell">
                    按比例设置：<el-input-number
                      v-model="shop.living_rate"
                      :step="10"
                      size="mini"
                      :min="0"
                      style="width: 100px"
                      @change="changeNum2(shop)"
                    ></el-input-number>
                    %
                  </div>
                </div>
              </div>
            </span>
          </el-col>
        </el-row> -->

        <div style="height: 40px; width: 100%"></div>
        <div class="btnBox">
          <div class="btnItem" @click="handleClose">取消</div>
          <div class="btnItem submit" @click="submit_check">确定</div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //周目标
      week_target_list: [],
      week_list: [],
      week_value: [],
      weekValue: [],
      arr: [],
      drawerStatus: true,
      datas: {
        shop_setting_list: [{},  {}, {}, {}],
        week_setting_list: [
          {
            weekName: "第一周",
            datePickerValue: ["", ""],
            week_name: "",
            begin_time: "",
            end_time: "",
            weekTarget: [],
          },
        ],
      },
    };
  },
  computed: {},
  props: {},

  mounted() {
    this.getSetting();
  },
  updated() {
    this.$nextTick(() => {
      let weeks = document.getElementsByClassName("week");
      this.week_list = Array.prototype.slice.call(weeks);
      // console.log(this.week_list);
      if (this.weekValue.length) {
        if (this.weekValue.length == this.week_list.length) {
          for (let i = 0; i < this.weekValue.length; i++) {
            this.week_list[i].value = this.weekValue[i];
          }
        }
      }
    });
  },
  methods: {
    //只回显年月日
    getTime(time) {
      // 时间戳为10位需要*1000，时间戳位13位不需要
      var data = new Date(time);
      var year = data.getFullYear() + "-"; //获取完整年份  4位
      var month =
        (data.getMonth() + 1 < 10
          ? "0" + (data.getMonth() + 1)
          : data.getMonth() + 1) + "-"; //获取月份（0-11） 如果月份小于10显示为01，02
      var day =
        data.getDate() < 10 ? "0" + data.getDate() : data.getDate() + " "; //获取日（1-31）  小于10为01，02
      return year + month + day;
    },

    handleClose() {
      this.$emit("submit", { type: "close" });
    },
    submit_check() {
      let week_value = [];

      for (let i = 0; i < this.week_list.length; i++) {
        week_value.push(this.week_list[i].value - 0);
      }
      this.week_value = week_value;
      console.log("时间1111111", this.datas.week_setting_list);
      let week_setting_list = [];
      for (let i = 0; i < this.datas.week_setting_list.length; i++) {
        week_setting_list.push({
          week_name: this.datas.week_setting_list[i].weekName,
          begin_time: this.$public.FTimeStr10(
            this.datas.week_setting_list[i].datePickerValue[0]
          ),
          end_time:
            parseInt(
              this.$public.FTimeStr10(
                this.datas.week_setting_list[i].datePickerValue[1]
              )
            ) +
            parseInt(86399) +
            "",
        });
      }
      for (let i = 0; i < this.week_list.length; i++) {
        if (this.week_list[i].value == 0 || this.week_list[i].value == "") {
          this.$message({
            message: "周目标不能为空",
            type: "error",
          });
          return;
        }
      }

      let shop_setting_list = [];
      let num = week_value.length / 4;
      for (let i = 0; i < this.datas.shop_setting_list.length; i++) {
        shop_setting_list.push({
          shop_info: {
            shop_id: this.datas.shop_setting_list[i].shop_info.shop_id,
            shop_name: this.datas.shop_setting_list[i].shop_info.shop_name,
          },
          month_target: this.datas.shop_setting_list[i].month_target || 0,
          living_target: this.datas.shop_setting_list[i].living_target || 0,
          week_target: 0,
          // week_target_list每周目标
          week_target_list: week_value.splice(0, num),
          last_month_performance:
            this.datas.shop_setting_list[i].last_month_performance,
          last_living_performance:
            this.datas.shop_setting_list[i].last_living_performance,
        });
      }
      let staff_setting_list = this.datas.staff_setting_list;
      let params = {
        _id: this.datas._id,
        month_info: this.datas.month_info,
        week_setting_list: week_setting_list,
        shop_setting_list: shop_setting_list,
        staff_setting_list: staff_setting_list,
      };
      console.log("params", params);
      this.$http
        .post(
          process.env.VUE_APP_Url9 +
            "api/ShopPerformancePKService/AddShopPerformanceSetting",
          params
        )
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              message: "设置成功",
              type: "success",
            });
            this.$emit("submit", { type: "success" });
          }
        });
    },
    getSetting() {
      let loading = this.$loading();
      let params = {
        month_info: this.$public.FTime(
          sessionStorage.getItem("pkMonth"),
          "YYYY-MM"
        ),
      };
      this.$http
        .get(
          process.env.VUE_APP_Url9 +
            "api/ShopPerformancePKService/GetShopPerformanceSettingViewModel",
          params
        )
        .then((res) => {
          loading.close();
          this.drawerStatus = true;
          console.log("11111月目标信息", res);
          if (res.code == 0) {
            let datas = res.data;
            if (datas.week_setting_list.length === 0) {
              datas.week_setting_list.push({
                weekName: "第一周",
                datePickerValue: ["", ""],
                week_name: "",
                begin_time: "",
                end_time: "",
              });
            } else {
              for (let i = 0; i < datas.week_setting_list.length; i++) {
                datas.week_setting_list[i].weekName =
                  datas.week_setting_list[i].week_name;
                datas.week_setting_list[i].datePickerValue = [
                  this.getTime(datas.week_setting_list[i].begin_time * 1000),
                  this.getTime(datas.week_setting_list[i].end_time * 1000),
                ];
                datas.week_setting_list[i].weekTarget =
                  datas.week_setting_list[i].week_target_list;
              }
            }
            let weekValue = [];
            for (let i = 0; i < datas.shop_setting_list.length; i++) {
              weekValue.push(datas.shop_setting_list[i].week_target_list);
            }
            this.weekValue = weekValue.flat(Infinity);
            console.log("周目标参数", this.weekValue);

            for (let i = 0; i < datas.shop_setting_list.length; i++) {
              datas.shop_setting_list[i].month_rate = 0;
              datas.shop_setting_list[i].living_rate = 0;
            }
            this.datas = datas;
          }
        });
    },

    changeDatePickerValue(e) {
      console.log(e);
    },
    jia() {
      let len = this.datas.week_setting_list.length;
      this.datas.week_setting_list.push({
        weekName: "第" + this.$public.formatNumTochinese(len + 1) + "周",
        datePickerValue: ["", ""],
        week_name: "",
        begin_time: "",
        end_time: "",
      });
    },
    jian() {
      let len = this.datas.week_setting_list.length;
      this.datas.week_setting_list.splice(len - 1, 1);
    },
    inputMoney1(shop) {
      shop.month_rate = 0;
    },
    changeNum1(shop) {
      shop.month_target = this.$public.cheng(
        shop.last_month_performance,
        shop.month_rate / 100
      );
    },
    inputMoney2(shop) {
      shop.living_rate = 0;
    },
    changeNum2(shop) {
      shop.living_target = Math.ceil(
        this.$public.cheng(shop.last_living_performance, shop.living_rate / 100)
      );
    },
  },
};
</script>

<style scoped lang="scss">
.drawer {
  width: 100%;
  padding: 0 0 0 0;
  ::v-deep.el-drawer {
    .el-drawer__body {
      overflow-y: auto;
      padding-bottom: 30px;
    }
    .avatar {
      width: 220px;
      display: block;
      margin: 150px auto 80px;
    }
    .row {
      padding: 20px 20px 0;
      float: none;
      font-size: 20px;
      .label {
        display: inline-block;
        width: 150px;
        text-align: right;
        font-size: 14px;
        color: $fontColor;
        vertical-align: top;
      }
      .value {
        display: inline-block;
        font-size: 14px;
        color: $fontColor;
        .table {
          border: 1px solid #e7e7e7;
          border-right: 0;
          border-bottom: 0;
          width: 1400px;
          margin-left: 10px;
          .tableRow {
            display: flex;
            border-bottom: 1px solid #e7e7e7;
            .cell {
              border-right: 1px solid #e7e7e7;
              height: 50px;
              width: 100%;
              text-align: center;
              padding: 8px 0;
              box-sizing: border-box;
              line-height: 32px;
            }
          }
        }
      }
    }
  }
}
.btnBox {
  width: 100%;
  font-size: 14px;
  color: #fff;
  line-height: 40px;
  display: flex;
  position: absolute;
  bottom: 0;
  z-index: 10;
  .btnItem {
    text-align: center;
    width: 100%;
    background-color: #d6d6d6;
    cursor: pointer;
    &.submit {
      background-color: $mainColor;
    }
  }
}
</style>
